/**
 * Custom News Section - スクロール＆ドラッグ機能
 */

class NewsScrollHandler {
  constructor(container) {
    this.container = container;
    this.grid = container.querySelector('[data-news-grid]');
    this.prevBtn = container.querySelector('.news-nav-btn--prev');
    this.nextBtn = container.querySelector('.news-nav-btn--next');
    
    if (!this.grid) return;
    
    // ドラッグ用変数
    this.isDragging = false;
    this.isMouseDown = false;
    this.startX = 0;
    this.scrollLeft = 0;
    this.dragThreshold = 5; // この距離以上動いたらドラッグと判定
    
    this.init();
  }
  
  init() {
    // ナビゲーションボタンのイベント
    if (this.prevBtn && this.nextBtn) {
      this.prevBtn.addEventListener('click', () => this.scroll(-1));
      this.nextBtn.addEventListener('click', () => this.scroll(1));
      this.updateButtons();
      this.grid.addEventListener('scroll', () => this.updateButtons());
    }
    
    // ドラッグイベント
    this.grid.addEventListener('mousedown', (e) => this.startDragging(e));
    this.grid.addEventListener('mousemove', (e) => this.drag(e));
    this.grid.addEventListener('mouseup', (e) => this.stopDragging(e));
    this.grid.addEventListener('mouseleave', () => this.stopDragging());
    
    // リンククリックの制御
    this.grid.addEventListener('click', (e) => this.handleClick(e));
  }
  
  // ボタンスクロール
  scroll(direction) {
    const scrollAmount = 600; // 1列分のスクロール量
    this.grid.scrollBy({
      left: scrollAmount * direction,
      behavior: 'smooth'
    });
  }
  
  // ボタンの有効/無効を更新
  updateButtons() {
    const { scrollLeft, scrollWidth, clientWidth } = this.grid;
    
    if (this.prevBtn) {
      this.prevBtn.disabled = scrollLeft <= 0;
    }
    
    if (this.nextBtn) {
      this.nextBtn.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
    }
  }
  
  // ドラッグ開始（まだドラッグ状態にはしない）
  startDragging(e) {
    this.isMouseDown = true;
    this.isDragging = false; // まだドラッグ状態ではない
    this.startX = e.pageX - this.grid.offsetLeft;
    this.scrollLeft = this.grid.scrollLeft;
  }
  
  // ドラッグ中
  drag(e) {
    if (!this.isMouseDown) return;
    
    const x = e.pageX - this.grid.offsetLeft;
    const walk = x - this.startX;
    
    // 閾値を超えたらドラッグと判定
    if (!this.isDragging && Math.abs(walk) > this.dragThreshold) {
      this.isDragging = true;
      this.grid.classList.add('is-dragging');
    }
    
    if (this.isDragging) {
      e.preventDefault();
      this.grid.scrollLeft = this.scrollLeft - walk * 1.5; // スクロール速度調整
    }
  }
  
  // ドラッグ終了
  stopDragging() {
    this.isMouseDown = false;
    // 少し遅延させてからドラッグ状態を解除（クリックイベントの後に実行されるように）
    setTimeout(() => {
      this.isDragging = false;
      this.grid.classList.remove('is-dragging');
    }, 0);
  }
  
  // クリックハンドラ：ドラッグ中ならクリックをキャンセル
  handleClick(e) {
    if (this.isDragging) {
      e.preventDefault();
      e.stopPropagation();
    }
  }
}

// 初期化
document.addEventListener('DOMContentLoaded', () => {
  const newsContainers = document.querySelectorAll('.news-section');
  newsContainers.forEach(container => {
    new NewsScrollHandler(container);
  });
});
